import "./styles.less";

import React from "react";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { EmblaCarousel } from "src/Components/EmblaCarousel";
import { ListingCard, ListingData } from "shared-components/ViewFragments/SearchPage/ListingCard";

export interface HomeProjectsCarouselSectionProps {
	sectionClassName: string;
	carouselTitle: string;
	title: string;
	subtitle: string;
	viewAllLabel: string;
	viewAllHref: string;
	items: ListingData[];
}

export const HomeProjectsCarouselSection: React.FC<HomeProjectsCarouselSectionProps> = ({
	sectionClassName,
	carouselTitle,
	title,
	subtitle,
	viewAllLabel,
	viewAllHref,
	items,
}) => {
	const screen = useBreakpoint();

	if (!items.length) return null;

	return (
		<div className={`container home-projects-carousel-section-container ${sectionClassName}`}>
			<header className="home-projects-carousel-section-container__header">
				<div className="home-projects-carousel-section-container__header-text">
					<h2 className="home-projects-carousel-section-container__title">
						{title}
					</h2>
					<p className="home-projects-carousel-section-container__subtitle body body-1 body-regular medium">
						{subtitle}
					</p>
				</div>
				<a className="home-projects-carousel-section-container__view-all" href={viewAllHref}>
					{viewAllLabel}
				</a>
			</header>

			<EmblaCarousel
				options={{
					slidesPerView: screen.md ? 4 : screen.sm ? 2 : screen.xs ? 1 : 4,
					navigation: true,
					slidesToScroll: 1,
					align: "center",
					breakpoints: {
						"(min-width:768px)": { slidesToScroll: 4, align: "start" },
					},
				}}
				className="property-similars-cards"
				totalSlides={items.length}
				title={carouselTitle}
			>
				{items.map((item, i) => (
					<div key={`${carouselTitle}_${item.id}`} className="similar">
						<ListingCard
							shortCard={true}
							data={item}
							preloadImg={i < 3}
							hideCta
							staticGallery
							showExpenses={false}
						/>
					</div>
				))}
			</EmblaCarousel>
		</div>
	);
};
